<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("little jar module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_little_jar"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_little_jar">{{
            $t("integrate")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <little-jars-datatable />

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- <provider-modal ref="provider_modal" @success="provider_configured" /> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
// import ProviderModal from "./emitters_datatable/provider_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import LittleJarsDatatable from "./little_jars_datatable/Index.vue";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";

export default {
  name: "LittleJarSettings",
  components: { /* ProviderModal */ LittleJarsDatatable, GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    // add_provider() {
    //   let v = this;
    //   v.meta.providers.push({ name: "" });
    // },
    // configure_provider(provider) {
    //   let v = this;
    //   v.$refs.provider_modal.show_modal(provider);
    // },
    provider_configured(data) {
      console.log("provider_configured", data);
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;
        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
